// src/data/galleryData.js
export const galleryImages = [
  {
    id: 1,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.30.35.jpeg'
  },
  {
    id: 2,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.30.35 (1).jpeg'
  },
  {
    id: 3,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.30.36.jpeg'
  },
  {
    id: 4,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.30.36 (1).jpeg'
  },
  {
    id: 5,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.32.15.jpeg'
  },
  {
    id: 6,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.32.15 (1).jpeg'
  },
  {
    id: 7,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.32.16.jpeg'
  },
  {
    id: 8,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.40.55.jpeg'
  },
  {
    id: 9,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.40.57.jpeg'
  },
  {
    id: 10,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.40.58.jpeg'
  },
  {
    id: 11,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.41.06.jpeg'
  },
  {
    id: 12,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.41.06 (1).jpeg'
  },
  {
    id: 13,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.41.07.jpeg'
  },
  {
    id: 14,
    url: '/assets/images/WhatsApp Image 2025-01-28 at 16.41.09.jpeg'
  }
];
